import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=4662ec28&scoped=true"
import script from "./UserForm.ts?vue&type=script&lang=ts&external"
export * from "./UserForm.ts?vue&type=script&lang=ts&external"
import style0 from "./UserForm.scss?vue&type=style&index=0&id=4662ec28&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4662ec28",
  null
  
)

export default component.exports